<script setup lang="ts">
const {color= "white"} = defineProps<{
    color?: string;
}>();
</script>

<template>
  <div
    class="flex flex-1 flex-col gap-5 p-4 rounded-lg shadow-md w-full min-h-0"
    :style="{'background-color': color}"
  >
    <slot />
  </div>
</template>
